import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import BannerService from 'api/BannerService';

export const useAdminAllBanners = (params) => {
    return useQuery({
        queryKey: ['adminAllBanners', params],
        queryFn: () => BannerService.getAdminBanners(params),
        keepPreviousData: true,
        staleTime: 5 * 60 * 1000 // cache for 5 minutes
    });
};

export const useAdminGetBanner = (id) => {
    return useQuery({
        queryKey: ['adminBanner', id],
        queryFn: () => BannerService.getBanner(id),
        staleTime: 1 * 1000,
        enabled: !!id
    });
};

export const useAdminCreateBanner = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: BannerService.createBanner,
        onSuccess: () => {
            queryClient.invalidateQueries(['adminAllBanners']);
        }
    });
};

export const useAdminUpdateBanner = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, data }) => BannerService.updateBanner(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries(['adminAllBanners']);
            queryClient.invalidateQueries(['adminBanner']);
        }
    });
};

export const useAdminDeleteBanner = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: BannerService.deleteBanner,
        onSuccess: () => {
            queryClient.invalidateQueries(['adminAllBanners']);
        }
    });
};
